import {
  CaretDownFilled,
  CloseOutlined,
  FilterOutlined,
  InfoCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Form,
  Input,
  Row,
  Select,
  Space,
  Cascader as Cascaded,
  Col,
  Popover,
  notification,
  TimePicker,
  Dropdown,
  Menu,
  Checkbox,
  Tag,
} from 'antd'
import moment from 'moment'
import React, {
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { selectInsuranceArray, selectUserId } from '../../../app/applicationSlice'
import { RootDispatch } from '../../../app/store'
import {
  DateRangeType,
  DateSelect,
  getDateRange,
  TJFXTime,
} from '../../../compnents/form/DateSelect'
import {
  BillingCategories,
  BillingCategoryName,
} from '../../../models/billingCategory'
import { User } from '../../../models/user'
import { PaymentListParams } from '../../../services/payment'
import { ThemeContext } from '../../../theme/ThemeContext'
import {
  getFullUserList,
  getRecipeItemCompletions,
  ItemCompletionType,
} from '../../completion/completionSlice'
import { getFullDoctorList } from '../../registration/list/registrationSlice'
import { FilterIconOutlined } from '../../../compnents/icons/Icons'
import styles from './transaction.module.css'
import { RecipeItemInput } from '../../treatment/editor/components/RecipeItemInput'
import { CommonCode } from '../../../models/commoncode'
import { getUsageCodesAsync } from '../../completion/completionSlice'
import { selectBooleanSetting } from '../../settings/settingsSlice'
import { Settings } from '../../../models/setting'
import { getCheckPermissionAsync } from '../../FunctionSetting/dataPermission/dataPermissionSlice'
import { SJQXChecks } from '../../../models/dataPersion'
import { FilterColumn } from '../../../compnents/filterForm/filterForm'
import { getPatientOptionsAsync } from '../../A-toothModule/toothHome/toothHomeSlice'

let timeout: ReturnType<typeof setTimeout> | null
let currentValue: string
export const Query = (props: {
  loading?: any
  selectedTab?: any
  filterColumn?: any
  filterSelectList?: any
  onValueChange: (params: PaymentListParams) => void
  submitPageList?: (selectedColumns: string[]) => void
  alertMessage: () => void
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const [popoverForm] = Form.useForm()

  const [open, setOpen] = useState(false)

  const inputRef = useRef<any>(null)

  const userId = useSelector(selectUserId)

  const { Option } = Select

  const location: any = useLocation()

  const insuranceArray = useSelector(selectInsuranceArray)

  const [doctors, setDoctors] = useState<any>([])

  const [users, setUsers] = useState<User[]>([])

  const [isInTimeRange, setIsInTimeRange] = useState(false)

  const [YSCKData, setYSCKData] = useState<any>()

  const [chargeTime, setChargeTime] = useState<any>([])

  const [selectedValues, setSelectedValues] = useState<any[]>([])

  const [searchValue, setSearchValue] = useState<any>('')

  const [classificationList, setClassificationList] = useState<any>() //自定义患者来源数据

  const [completionType, setCompletionType] = useState<any>(
    ItemCompletionType.Treatment
  )

  const [usageOptions, setUsageOptions] = useState<CommonCode[]>([])
  const [usageDropdownVisible, setUsageDropdownVisible] = useState(false)
  const [selectedUsageCodes, setSelectedUsageCodes] = useState<string[]>([])

  const fetchUsageOptions = () => {
    dispatch(getUsageCodesAsync())
      .then(unwrapResult)
      .then((data: any) => {
        const records = data?.records || []
        setUsageOptions(records.map((c: any) => ({
          id: c.id?.toString() || '',
          name: c.codeName,
          code: c.mnemonicCode,
          codeCalc: c.codeCalc,
        })))
      })
      .catch(() => {
        // 忽略获取用法列表失败
      })
  }

  const useSpecifiedBatch = useSelector(
    selectBooleanSetting(Settings.Recipe.UseSpecifiedBatch)
  )

  useEffect(() => {
    if (YSCKData == 1) {
      form.setFieldsValue({
        treatmentDoctorId: userId,
      })
    }
  }, [YSCKData])

  useEffect(() => {
    dispatch(getFullDoctorList())
      .then(unwrapResult)
      .then((ds) => setDoctors(ds))
      .catch(() => {
        // do nothing
      })
    getCheckPermissionFn()
    // 获取患者来源字典
    dispatch(getPatientOptionsAsync({ types: '0,1,2' }))
      .then(unwrapResult)
      .then((res: any) => {
        const findItems = (type: string) => {
          return res ? res?.find((t: any) => t.type == type)?.items?.map((v: any) => {
            return {
              name: v.context,
              value: v.sortNo,
            }
          }) : []
        }
        setClassificationList({
          sourceList: findItems('1'),
        })
      })
  }, [])

  // 获取医生查看交易查询权限
  const getCheckPermissionFn = () => {
    dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.YSCKJYCX }))
      .then(unwrapResult)
      .then((res) => {
        setYSCKData(res)
      })
  }

  useEffect(() => {
    dispatch(getFullUserList({ current: 1, size: 1000, state: 1 }))
      .then(unwrapResult)
      .then((users) => setUsers(users))
      .catch(() => {
        // do nothing.
      })
  }, [])

  const fetchData = (
    value: string,
    callback: (data: { value: string; text: string }[]) => void
  ) => {
    if (timeout) {
      clearTimeout(timeout)
    }
    currentValue = value

    timeout = setTimeout(() => {
      dispatch(
        getRecipeItemCompletions({
          type: ItemCompletionType.Material,
          keyword: value,
          current: 1,
          isFullMatch: 0,
          insuranceCode: insuranceArray?.[0]?.insuranceCode,
          isRestrictUser: 1,
        })
      )
        .then(unwrapResult)
        .then((res: any) => {
          // if (currentValue === value) {  // 确保结果对应最新输入
          callback(res?.items || [])
          // }
        })
    }, 300)
  }

  const checkTimeRange = () => {
    const now = moment()
    const currentHour = now.hours()

    // 判断当前时间是否在给定的时间段内
    if (
      (currentHour >= 10 && currentHour < 12) ||
      (currentHour === 12 && now.minutes() === 0) ||
      (currentHour >= 14 && currentHour < 16) ||
      (currentHour >= 19 && currentHour <= 23) ||
      (currentHour >= 0 && currentHour < 6)
    ) {
      setIsInTimeRange(true)
    } else {
      setIsInTimeRange(false)
    }
  }

  useEffect(() => {
    checkTimeRange()
  }, [])

  return (
    <Form
      form={form}
      onFinish={(values) => {
        if (!values?.timeHead && values?._dateRange == 6) {
          return
        }
        props.onValueChange({
          ...values,
          current: 1,
          time: null,
          billingCategory: popoverForm?.getFieldValue('billingCategory'),
          payMethod: popoverForm?.getFieldValue('payMethod'),
          medicationUsageNameListToStr: (popoverForm?.getFieldValue('medicationUsageNameListToStr') || []).join(','),
          multiSearchIds:
            selectedValues?.length >= 2
              ? encodeURIComponent(
                JSON.stringify(
                  selectedValues?.map((v) => ({
                    localItemId: v.id,
                    drugType: v.drugType,
                  }))
                )
              )
              : undefined,
          chargeTimeStart: chargeTime?.[0] ? moment(chargeTime?.[0])?.format('HH:mm') : undefined,
          chargeTimeEnd: chargeTime?.[1] ? moment(chargeTime?.[1])?.format('HH:mm') : undefined,
        })
      }}
    >
      <Row
        style={{ marginBottom: 10 }}
        justify='space-between'
        className={styles.filterButton}
      >
        <Space wrap>
          <Form.Item noStyle name='param'>
            <Input
              autoComplete='off'
              prefix={<SearchOutlined />}
              placeholder='患者姓名/药品名称/手机号/病历号'
              style={{ width: '16.9rem' }}
              allowClear
              onChange={() => {
                form.submit()
              }}
            />
          </Form.Item>
          <Form.Item noStyle name='disease'>
            <Input
              autoComplete='off'
              prefix={<SearchOutlined />}
              placeholder='诊断搜索'
              style={{ width: '7.2rem' }}
              allowClear
              onChange={() => {
                form.submit()
              }}
            />
          </Form.Item>
          {insuranceArray && insuranceArray.length !== 0 && (
            <Form.Item name='insuranceCode' noStyle>
              <Select
                placeholder='险种类型'
                style={{ width: '6.3rem' }}
                allowClear
                onChange={() => {
                  form.submit()
                }}
              >
                <Select.Option value={''}>全部</Select.Option>
                <Select.Option value={'ZIFEI'}>自费</Select.Option>
                <Select.Option value={'0'}>本地</Select.Option>
                <Select.Option value={'1'}>省内异地</Select.Option>
                <Select.Option value={'2'}>省外异地</Select.Option>
                <Select.Option value={'3'}>省医保</Select.Option>
                {/* {insuranceArray.map((v) => (
                  <Select.Option value={v.insuranceCode} key={v.id}>
                    {v.insuranceName}
                  </Select.Option>
                ))} */}
              </Select>
            </Form.Item>
          )}

          <Form.Item name='drugType' noStyle>
            <Select
              placeholder='项目类别'
              style={{ width: '6.3rem' }}
              allowClear
              onChange={() => {
                form.submit()
              }}
            >
              <Select.Option value={0}>药品</Select.Option>
              <Select.Option value={1}>诊疗</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name='patientSource' noStyle>
            <Select
              allowClear
              placeholder='患者来源'
              style={{ width: '6.3rem' }}
              onChange={() => {
                form.submit()
              }}
            >
              {classificationList?.sourceList.map((v: any) => {
                return (
                  <Select.Option key={v.name} value={v.name}>
                    {v.name}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='treatmentDoctorId' noStyle>
            <Select
              disabled={YSCKData == 1 ? true : false}
              allowClear
              placeholder='接诊医生'
              style={{
                width: '6.3rem',
              }}
              onChange={() => {
                form.submit()
              }}
            >
              {doctors.map((d: any) => (
                <Select.Option key={d.id} value={d.id}>
                  {d.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name='state' noStyle>
            <Select
              placeholder='结算状态'
              style={{ width: '6.3rem' }}
              allowClear
              // suffixIcon={<CaretDownFilled />}
              onChange={() => {
                form.submit()
              }}
            >
              <Select.Option key={3} value={3}>
                已收费
              </Select.Option>
              <Select.Option key={5} value={5}>
                已退费
              </Select.Option>
              <Select.Option key={7} value={7}>
                欠费中
              </Select.Option>
            </Select>
          </Form.Item>
          <DateSelect
            allowClear={false}
            style={{ width: '6rem' }}
            labelPrefix=''
            namePrefix='time'
            options={TJFXTime}
            placeholder='时间范围-时间'
            initialValue={DateRangeType.Today}
            onChange={() => {
              form.submit()
            }}
          />
          {/* <Col flex={1}> */}
          <Popover
            visible={open}
            overlayClassName={styles.formQueryPopover}
            content={
              <>
                <Form
                  form={popoverForm}
                  onFinish={(val) => {
                    form.submit()
                    setOpen(false)
                  }}
                >
                  <Row
                    className={styles.chargeTime}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: 18,
                      paddingRight: 20,
                    }}
                  >
                    <span
                      style={{
                        width: 100,
                        textAlign: 'right',
                        fontSize: '16px',
                      }}
                    >
                      开票项目：
                    </span>
                    <Form.Item name='billingCategory' noStyle>
                      <Select
                        placeholder='开票项目'
                        style={{ width: '262px' }}
                        allowClear
                      >
                        {BillingCategories.map((v) => {
                          return (
                            <Option value={v} key={v}>
                              {BillingCategoryName(v)}
                            </Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </Row>
                  <Row
                    className={styles.chargeTime}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: 18,
                      paddingRight: 20,
                    }}
                  >
                    <span
                      style={{
                        width: 100,
                        textAlign: 'right',
                        fontSize: '16px',
                      }}
                    >
                      支付方式：
                    </span>
                    <Form.Item name='payMethod' noStyle>
                      <Select
                        placeholder='支付方式'
                        style={{ width: '262px' }}
                        allowClear
                      >
                        <Select.Option value={1}>现金</Select.Option>
                        <Select.Option value={2}>聚合支付</Select.Option>
                        <Select.Option value={3}>支付宝</Select.Option>
                        <Select.Option value={4}>微信</Select.Option>
                        <Select.Option value={5}>银联</Select.Option>
                        <Select.Option value={6}>会员卡 </Select.Option>
                        <Select.Option value={99}>医保</Select.Option>
                        <Select.Option value={7}>其他 </Select.Option>
                      </Select>
                    </Form.Item>
                  </Row>
                  <Row
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: 18,
                      paddingRight: 20,
                    }}
                  >
                    <span
                      style={{
                        width: 100,
                        textAlign: 'right',
                        fontSize: '16px',
                      }}
                    >
                      串换项目：
                    </span>
                    <Popover
                      content={
                        <div>
                          支持查询2个或3个项目同时开在一次就诊内的数据，项目合并查询
                        </div>
                      }
                      placement='right'
                      title='说明'
                    >
                      <InfoCircleOutlined
                        style={{ color: '#5896FF', fontSize: '16px' }}
                      />
                    </Popover>
                    <Select
                      style={{
                        color: theme.tc1,
                        fontSize: '1rem',
                        width: '5rem',
                        height: '2rem',
                        backgroundColor: theme.c3,
                        margin: '0 10px 0 22px',
                      }}
                      value={
                        completionType === ItemCompletionType.Treatment ? 1 : 0
                      }
                      onChange={(v) => {
                        if (v === 1) {
                          setCompletionType(ItemCompletionType.Treatment)
                        } else {
                          setCompletionType(ItemCompletionType.Auto)
                        }
                      }}
                      bordered={false}
                      className={styles.select}
                    >
                      <Select.Option value={0}>药品</Select.Option>
                      <Select.Option value={1}>诊疗</Select.Option>
                    </Select>
                    <RecipeItemInput
                      noSetting={true}
                      isRestrictUser={1} //是否限制用户
                      style={{
                        flex: 1,
                        height: '2rem',
                        color: theme.tc1,
                      }}
                      // category={RecipeCategory.ShuZhuFang}
                      placeholder='输入名称/助记码搜索'
                      autoFocus={selectedValues?.length ? true : false}
                      type={completionType}
                      value={searchValue}
                      useSpecifiedBatch={useSpecifiedBatch}
                      ignoreStorage={true}
                      onSelect={(m, ignoreStorage) => {
                        const flag = selectedValues.filter(
                          (t: any) => t.id === m.id
                        )
                        setSearchValue('')
                        if (selectedValues?.length + 1 > 3) {
                          notification.info({
                            message: '串换项目最多添加3个',
                          })
                          return
                        }
                        if (!flag.length) {
                          setSelectedValues(
                            selectedValues.concat([
                              {
                                id: m.id,
                                name: m.name,
                                drugType:
                                  completionType == ItemCompletionType.Treatment
                                    ? 1
                                    : 0,
                              },
                            ])
                          )
                        }
                      }}
                      onChange={(v) => {
                        setSearchValue(v)
                      }}
                    />
                  </Row>
                  <Row className={styles.diseaseList}>
                    <Col style={{ marginLeft: 138 }}>
                      {selectedValues?.map((d, index) => (
                        <div key={index} className={styles.disease}>
                          {d.name}
                          <CloseOutlined
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              const list = [...selectedValues]
                              list.splice(index, 1)
                              setSelectedValues(list)
                            }}
                          />
                        </div>
                      ))}
                    </Col>
                  </Row>
                  <Row
                    className={styles.chargeTime}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: 18,
                      paddingRight: 20,
                    }}
                  >
                    <span
                      style={{
                        width: 100,
                        textAlign: 'right',
                        fontSize: '16px',
                      }}
                    >
                      收费时间：
                    </span>
                    <Form.Item name='time'>
                      <TimePicker.RangePicker
                        value={chargeTime}
                        onChange={(v) => {
                          if (!v) return
                          setChargeTime(v)
                        }}
                        format='HH:mm'
                      />
                    </Form.Item>
                  </Row>
                  <Row
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: 18,
                      paddingRight: 20,
                    }}
                  >
                    <span
                      style={{
                        width: 100,
                        textAlign: 'right',
                        fontSize: '16px',
                      }}
                    >
                      用法：
                    </span>
                    <Form.Item name='medicationUsageNameListToStr' noStyle>
                      <Dropdown
                        trigger={['click']}
                        placement="topCenter"
                        visible={usageDropdownVisible}
                        onVisibleChange={(v) => setUsageDropdownVisible(v)}
                        overlay={
                          <div style={{
                            width: 500,
                            background: theme.pn,
                            boxShadow: '0 3px 6px -4px rgba(0,0,0,0.12), 0 6px 16px 0 rgba(0,0,0,0.08), 0 9px 28px 8px rgba(0,0,0,0.05)',
                            borderRadius: 6,
                            overflow: 'hidden',
                          }}>
                            <div style={{
                              maxHeight: 200,
                              overflowY: 'auto',
                              padding: '4px',
                              display: 'flex',
                              flexWrap: 'wrap',
                              gap: 6,
                            }}>
                              {usageOptions.map((item) => {
                                const isSelected = selectedUsageCodes.includes(item.name)
                                return (
                                  <div
                                    key={item.id}
                                    style={{
                                      width: 'calc(25% - 5px)',
                                      cursor: 'pointer',
                                      backgroundColor: isSelected ? theme.c3 : 'transparent',
                                      borderRadius: 4,
                                      textAlign: 'center',
                                      fontSize: 14,
                                      lineHeight: '2rem',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      const newCodes = isSelected
                                        ? selectedUsageCodes.filter(c => c !== item.name)
                                        : [...selectedUsageCodes, item.name]
                                      setSelectedUsageCodes(newCodes)
                                      popoverForm.setFieldsValue({ medicationUsageNameListToStr: newCodes })
                                    }}
                                  >
                                    {item.name}({item.code})
                                  </div>
                                )
                              })}
                            </div>
                            <div style={{
                              textAlign: 'center',
                              padding: '6px 0',
                              cursor: 'pointer',
                              borderTop: '1px solid #f0f0f0',
                              color: theme.c1,
                              fontWeight: 'bold',
                              backgroundColor: theme.c3,
                            }} onClick={() => setUsageDropdownVisible(false)}>
                              关闭(ESC)
                            </div>
                          </div>
                        }
                      >
                        <div
                          style={{
                            width: 262,
                            minHeight: 32,
                            border: `1px solid ${usageDropdownVisible ? theme.c1 : '#d9d9d9'}`,
                            borderRadius: 6,
                            padding: selectedUsageCodes.length > 0 ? '2px 11px' : '0 11px',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            cursor: 'pointer',
                            background: theme.pn,
                            gap: 2,
                            boxSizing: 'border-box',
                          }}
                        >
                          {selectedUsageCodes.length === 0 ? (
                            <span style={{ color: '#bfbfbf', lineHeight: '30px' }}>请选择用法</span>
                          ) : (
                            selectedUsageCodes.map(name => {
                              const item = usageOptions.find(o => o.name === name)
                              return (
                                <Tag
                                  key={name}
                                  closable
                                  style={{ marginBottom: 2, border: 'none', fontSize: 14 }}
                                  onClose={(e) => {
                                    e.preventDefault()
                                    const newCodes = selectedUsageCodes.filter(c => c !== name)
                                    setSelectedUsageCodes(newCodes)
                                    popoverForm.setFieldsValue({ medicationUsageNameListToStr: newCodes })
                                  }}
                                >
                                  {item ? `${item.name}(${item.code})` : name}
                                </Tag>
                              )
                            })
                          )}
                        </div>
                      </Dropdown>
                    </Form.Item>
                  </Row>
                  <Row
                    style={{
                      height: '1px',
                      background: '#f0f0f0',
                      marginTop: '10px',
                    }}
                  ></Row>
                  <Space
                    style={{
                      display: 'flex',
                      justifyContent: 'end',
                      marginTop: '10px',
                    }}
                  >
                    <Button
                      size='middle'
                      type={'ghost'}
                      onClick={() => {
                        setOpen(false)
                      }}
                    >
                      取消
                    </Button>
                    <Button
                      size='middle'
                      type='primary'
                      onClick={() => {
                        // if (selectedValues?.length < 2) {
                        //   notification.info({
                        //     message: '串换项目最少添加2个',
                        //   })
                        // } else {
                        form.submit()
                        setOpen(false)
                        // }
                      }}
                    >
                      确定
                    </Button>
                  </Space>
                </Form>
              </>
            }
            title=''
            trigger='click'
            placement='bottom'
            onVisibleChange={(v) => {
              setOpen(v)
              if (v) {
                fetchUsageOptions()
              }
            }}
          >
            <Form.Item name='' initialValue={'筛选'}>
              <Button
                style={{
                  color: theme.tc2,
                  width: '78px',
                  textAlign: 'left',
                  // overflow: 'hidden',
                  // textOverflow: 'ellipsis',
                }}
                icon={
                  <FilterIconOutlined
                    style={{
                      width: '14px',
                      height: '14px',
                      position: 'relative',
                      top: 2,
                      left: -2,
                      color: '#666',
                    }}
                  />
                }
                onClick={() => {
                  setOpen(true)
                  setChargeTime([])
                  popoverForm.setFieldsValue({
                    time: undefined
                  })
                }}
              >
                筛选
              </Button>
            </Form.Item>
          </Popover>
          {/* </Col> */}

          <Button
            type='primary'
            loading={props?.loading}
            onClick={() => {
              form.submit()
            }}
          >
            查询
          </Button>
          <FilterColumn
            filterColumn={props?.filterColumn}
            filterSelectList={props?.filterSelectList}
            // 筛选列变化时的数据
            onColumnVisibilityChange={(v: any) => {
              // 以 filterColumn 的顺序为基准，用 v 中的字段顺序重排，并保留 filterColumn 的 visible 状态
              const sortList = props?.filterColumn?.map((val: any) => {
                return {
                  ...val,
                  visible: v?.includes(val.field)
                }
              })
              props?.submitPageList && props?.submitPageList(sortList)
            }}
          />
          {isInTimeRange ? (
            <div
              style={{
                opacity: 0,
                cursor: 'pointer',
                width: '10px',
                height: '30px',
              }}
              onDoubleClick={() => {
                props?.alertMessage && props?.alertMessage()
              }}
            ></div>
          ) : (
            <></>
          )}
        </Space>
      </Row>
    </Form>
  )
}
